// import { useSelector } from "react-redux";
import axios from 'axios';
import { call, fork, takeEvery, put, delay, select } from "redux-saga/effects";
import { getFormValues } from 'redux-form';
// import Axios from "axios";
import actions from "modules/survey/actions";
import {
  setSurveyQuestions,
  setFormFieldValue,
  setSurveyStatus,
  setIsLoading,
  setSurveyToken,
  setSurveyBrand,
  setStartMessage,
  setEndMessage,
  setCancelMessage,
  setIsLastQuestion,
  selectSurveyStatus,
  selectSurveyToken,
  setSurveyQuestionPerPage,
  selectSurveyQuestionPerPage,
  setIsBusiness
} from "modules/survey/reducer";
import { getQuestions, submitAnswers } from "modules/survey/api"

// import { result } from "modules/survey/data";

import { urlToFile, urlBlobToFile, hasDisqualifyingAnswer, rotateQuestionAnswers } from "shared/utils";

export function* fetchSurveyQuestions() {
  try {
    // yield delay(1500);

    // Errors EXPIRED, INVALID...
    // yield put(setSurveyStatus('EXPIRED'));

    const language = localStorage.i18nextLng;
    // let status = yield select(selectSurveyStatus);

    if (!language || !['kz', 'ru'].includes(language)) {
      // console.log(1, !language || !['kz', 'ru'].includes(language));
      yield put(setSurveyStatus({
        code: 'SELECT_LANGUAGE'
      }));
    } else {
      // console.log(2, !language || !['kz', 'ru'].includes(language));
      yield put(setSurveyStatus({
        code: 'SUCCESSFUL'
      }));
    }

    yield put(setIsLoading(true));
    const hostname = window.location.hostname;

    const url = window.location;
    const token = new URLSearchParams(url.search).get('data');


    // console.log('token', token);
    if (!token) {
      // throw new Error('NO_TOKEN');
      // yield put(setSurveyStatus('NO_TOKEN'));
      // throw new Error('NO_TOKEN');
      throw {
        code: 'NO_TOKEN'
      }
    }

    yield put(setSurveyToken(token));

    // -----<<
    const result = yield call(() => getQuestions(token));
    // console.log('result', result);

    if (result?.data?.code !== 0) {
      // For a while status.message keeps code from api back-end
      //   and gets satisfying message from translations
      //   untill back-end start returning multi lingual messages
      throw {
        code: 'SURVEY_ERROR',
        // msg: result?.data?.message
        msg: result?.data?.code // since for now no multi lingual messages in DB
      };
    }

    if (!result?.data?.details?.questions) {
      // throw new Error('FETCH_ERROR');
      throw {
        code: 'FETCH_ERROR'
      }
    }

    if (result?.data?.details?.questionPerPage == null) {
      yield put(setSurveyQuestionPerPage(true));
      // throw {
      //   code: 'FETCH_ERROR'
      // }
    }

    // result.data.details.startMessage = {
    //   kz: 'Salem, Survey',
    //   ru: 'Hello, Survey'
    // }

    if (result?.data?.details?.startMessage) {
      yield put(setStartMessage(result.data.details.startMessage));

      if (['kz', 'ru'].includes(language)) {
        yield put(setSurveyStatus({ code: 'START_MESSAGE' }));
      }
    }

    if (result?.data?.details?.endMessage) {
      yield put(setEndMessage(result.data.details.endMessage));
    }

    if (result?.data?.details?.cancelMessage) {
      yield put(setCancelMessage(result.data.details.cancelMessage));
    }

    yield put(setSurveyQuestionPerPage(result.data.details.questionPerPage));
    yield put(setSurveyQuestions(rotateQuestionAnswers(result.data.details.questions)));

    yield put(setIsBusiness(result.data.details.business || false));
    // ----->>

    // -- for test
    // yield put(setSurveyQuestions(result_test.data));
    // yield put(setSurveyQuestionPerPage(result_test.questionPerPage));
    // -- for test

    // console.log('!2 hostname', hostname);

    if (hostname.includes("tele2")) {
      yield put(setSurveyBrand("tele2"));
    }

    if (hostname.includes("altel")) {
      yield put(setSurveyBrand("altel"));
    }

    if (hostname.includes("5gmobile")) {
      yield put(setSurveyBrand("fmobile"));
    }

    // yield put(setSurveyStatus('ERROR'));
    // } finally {
    //   yield put(setIsLoading(false));
    // }

  } catch (e) {
    console.error(e);
    // yield put(setSurveyStatus(e));
    yield put(setSurveyStatus({
      code: e.code,
      message: e.msg
    }));

    // if (e.code === 'SURVEY_ERROR') {
    //   yield put(setSurveyStatus({
    //     code: 'SURVEY_ERROR',
    //     message: e.msg
    //   }));
    // } else {
    //   yield put(setSurveyStatus({
    //     code: 'SUMBIT_ERROR'
    //   }));
    // }
  }
  yield put(setIsLoading(false));

}

// export function* assignFormFieldValue(payload) {
//   yield put(setFormFieldValue(payload))
// }

//---------------------------------------------

export function* submitSurveyAnswers(action) {
  // console.log('submitSurveyAnswers', action)

  try {
    yield put(setIsLoading(true));

    // TODO: add this stage
    yield put(setSurveyStatus({
      code: 'SUBMIT_LOADING'
    }));

    // yield delay(1000);
    // console.log('SUBMIT saga');
    const values = yield select(getFormValues('survey'));
    // console.log('SUBMIT values', values, action.payload.steps, action.payload.scenario);

    // const answerList = Object.keys(values).map(key => ({ q: key, value: values[key] }));
    let answerList = [];

    if (values && Object.keys(values).length > 0) {
      answerList = Object.keys(values).map(key => ({ q: key, value: values[key] }));
    }

    const validAnswerList = [];
    // console.log('SUBMIT answerList', answerList);
    const form = new FormData();
    const token = yield select(selectSurveyToken);
    // console.log("token", token)

    for (let answer of answerList) {
      // console.log("answer", answer);

      // const goToNext = action.payload.findIndex(r => r.id === answer.id) > -1 ? true : false
      // const goToNext = action.payload.findIndex(r => r.id === answer.value.id) > -1 ? true : false;

      const questionPerPage = yield select(selectSurveyQuestionPerPage);

      // console.log('questionPerPage', questionPerPage);

      if (questionPerPage) {
        if (!action.payload.scenario[answer.value?.id]) {
          // console.log('continue', answer.value?.id, action.payload.scenario[answer.value?.id]);
          continue;
        }
      } else {
        const goToNext = action.payload.steps.findIndex(r => r.id === answer.value?.id) > -1 ? true : false;
        // console.log("goToNext", goToNext, action.payload.steps.findIndex(r => r.id === answer.value?.id), answer);
        if (!goToNext) {
          continue;
        }
      }

      const value = structuredClone(answer?.value);

      if (value?.typeName === 'IMAGE-SELECT' && value.result?.length > 0) {
        for (const image of value.result) {
          if (image.blobValue != null) {
            image.blobValue = null;
          }
        }
        answer.value = value;
      }
      validAnswerList.push(answer);
    }

    const lang = action?.payload?.lang === 'kz' ? 3 : 1;
    const requestObj = {
      // values: answerList,
      values: validAnswerList,
      lang
    };

    // console.log('requestObj', requestObj, 'payload', action.payload);

    const value = new Blob([JSON.stringify(requestObj)], { type: "application/json" });
    form.append('request', value);

    // console.log('token', token, 'requestObj', JSON.stringify(requestObj));

    const result = yield call(submitAnswers, token, form);
    // console.log("SUBMIT result", result);

    if (result?.data?.code !== 0) {
      // yield put(setSurveyStatus('SUMBIT_ERROR'));
      // throw new Error('SURVEY_ERROR');
      throw {
        code: 'SURVEY_ERROR',
        msg: result?.data?.code //result?.data?.message
      };
    }

    if (action.payload?.lastQuestions && action.payload?.lastQuestions.length > 0) {
      if (!requestObj.values?.some(v => v?.value && action.payload.lastQuestions.some(q => q == v.value.id))) {
        yield put(setIsLastQuestion(false));
      }
    } else {
      yield put(setIsLastQuestion(false));
    }

    // If any submitted answer selects a disqualifying option, end the survey
    // with the cancel message regardless of how far the respondent got.
    if (validAnswerList.some(a => hasDisqualifyingAnswer(a.value))) {
      yield put(setIsLastQuestion(false));
    }

    // console.log('SUBMIT ANSWERS', ...form);
    // console.log('SUBMIT ANSWERS', JSON.stringify(answerList), validAnswerList);
    // console.log('SUBMIT ANSWERS', [...answerList]);

  } catch (e) {
    // console.error(1, e)
    // yield put(setSurveyStatus('SUMBIT_ERROR'));

    if (e.code === 'SURVEY_ERROR') {
      yield put(setSurveyStatus({
        code: 'SURVEY_ERROR',
        message: e.msg
      }));
    } else {
      yield put(setSurveyStatus({
        code: 'SUMBIT_ERROR'
      }));
    }

    // console.log(2);

    return;

    // console.log(3);

  } finally {
    // console.log(4);
    yield put(setIsLoading(false));
  }

  // console.log(5);

  yield put(setSurveyStatus('SUBMITTED'));

  // console.log(6);
}

//---------------------------------------------

export default function* sagas() {
  yield takeEvery(actions.FETCH_SURVEY_QUESTIONS, fetchSurveyQuestions);
  yield takeEvery(actions.SUBMIT_SURVEY_ANSWERS, submitSurveyAnswers);
}
